import { z } from 'zod';

export const userDirectorySearchSchema = z.object({
  q: z.string().trim().min(1).optional().catch(undefined),
});

export function normalizeUserDirectoryQuery(value: string | null | undefined) {
  return value?.trim() || undefined;
}
